var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function () {
    angular.module('QMC.NewsFeed', []);
    angular.module('QMC.Login', ['QMC.NewsFeed']).run(['$rootScope', '$document', '$window', function ($rootScope, $document, $window) {
            function setCapsLockOn(isOn) {
                $rootScope.isCapsLockOn = isOn;
                $rootScope.$apply();
            }
            ;
            function bindingForAppleDevice() {
                $document.bind("keydown", function (event) {
                    if (event.keyCode === 20) {
                        setCapsLockOn(true);
                    }
                });
                $document.bind("keyup", function (event) {
                    if (event.keyCode === 20) {
                        setCapsLockOn(false);
                    }
                });
                $document.bind("keypress", function (event) {
                    var code = event.charCode || event.keyCode;
                    var shift = event.shiftKey;
                    if (code > 96 && code < 123) {
                        setCapsLockOn(false);
                    }
                    if (code > 64 && code < 91 && !shift) {
                        setCapsLockOn(true);
                    }
                });
            }
            ;
            function bindingForOthersDevices() {
                var isKeyPressed = true;
                $document.bind("keydown", function (event) {
                    if (event.originalEvent && event.originalEvent.getModifierState) {
                        return setCapsLockOn(event.originalEvent.getModifierState('CapsLock'));
                    }
                    if (!isKeyPressed && event.keyCode === 20) {
                        isKeyPressed = true;
                        if ($rootScope.isCapsLockOn) {
                            setCapsLockOn(!$rootScope.isCapsLockOn);
                        }
                    }
                });
                $document.bind("keyup", function (event) {
                    if (event.keyCode === 20) {
                        isKeyPressed = false;
                    }
                });
                $document.bind("keypress", function (event) {
                    var code = event.charCode || event.keyCode;
                    var shift = event.shiftKey;
                    if (code > 96 && code < 123) {
                        setCapsLockOn(shift);
                    }
                    if (code > 64 && code < 91) {
                        setCapsLockOn(!shift);
                    }
                });
            }
            ;
            // Once the window goes out of focus, we can't be sure of the caps lock state
            // so we have to default to not showing.
            $window.addEventListener('blur', function () {
                setCapsLockOn(false);
            });
            if (/Mac|iPad|iPhone|iPod/.test(navigator.platform)) {
                bindingForAppleDevice();
            }
            else {
                bindingForOthersDevices();
            }
        }]);
})();
var QMC;
(function (QMC) {
    var Login;
    (function (Login) {
        var LoginController = /** @class */ (function () {
            function LoginController(loginService, $scope, $q, $timeout) {
                var _this = this;
                this.loginService = loginService;
                this.$scope = $scope;
                this.$q = $q;
                this.$timeout = $timeout;
                this.targetVersion = [8, 2];
                this.isLoading = false;
                this.version = {
                    target: this.targetVersion.join('.'),
                    current: ""
                };
                this.loginForm = {
                    username: '',
                    password: ''
                };
                this.setPasswordForm = {
                    password1: '',
                    password2: ''
                };
                this.zfaInput = [
                    { value: undefined, index: 0 }, { value: undefined, index: 1 }, { value: undefined, index: 2 },
                    { value: undefined, index: 3 }, { value: undefined, index: 4 }, { value: undefined, index: 5 }
                ];
                this.errorMessage = "";
                this.loginStep = 'credentials';
                this.loginMode = "classic";
                this.usernameFieldState = { hidden: true, disabled: true };
                this.passwordFieldState = { hidden: true, disabled: true };
                // migrationToIdp
                this.loginModeMigrateToIdpStep = "enterusername";
                this.updatePasswordOnLoginSuccessfulRedirect = false;
                sessionStorage.clear();
                var sessionData = $('#session').data();
                this.baseRoute = sessionData.baseUrl;
                this.redirectRoute = sessionData.redirectRoute;
                this.loginMode = window.loginMode.toLocaleLowerCase();
                this.showScreen();
                if (this.baseRoute.length > 0 && !this.baseRoute.endsWith('/'))
                    this.baseRoute = this.baseRoute + '/';
                if (!this.redirectRoute.startsWith('/'))
                    this.redirectRoute = '/' + this.redirectRoute;
                this.init();
                $scope.$watchGroup(['vm.loginMode', 'vm.loginModeMigrateToIdpStep'], function () {
                    if (_this.loginMode.toLocaleLowerCase() == "classic") {
                        _this.usernameFieldState = { hidden: false, disabled: false };
                        _this.passwordFieldState = { hidden: false, disabled: false };
                    }
                    else if (_this.loginMode.toLocaleLowerCase() == "migratetoidp") {
                        if (_this.loginModeMigrateToIdpStep === 'enterusername') {
                            _this.usernameFieldState = { hidden: false, disabled: false };
                            _this.passwordFieldState = { hidden: true, disabled: false };
                        }
                        else {
                            _this.usernameFieldState = { hidden: false, disabled: true };
                            _this.passwordFieldState = { hidden: false, disabled: false };
                        }
                    }
                    else if (_this.loginMode.toLocaleLowerCase() == "idp") {
                        _this.usernameFieldState = { hidden: true, disabled: false };
                        _this.passwordFieldState = { hidden: true, disabled: false };
                    }
                });
            }
            LoginController.prototype.init = function () {
                var _this = this;
                this.isLoading = true;
                this.loginService.getVersion()
                    .then(function (data) {
                    _this.version.current = data.buildVersion;
                    var currentVersion = _this.version.current.split('.');
                    if (currentVersion.length === 0 || parseInt(currentVersion[0]) !== _this.targetVersion[0])
                        _this.handleWrongVersion();
                    if (currentVersion.length > 1 && parseInt(currentVersion[1]) !== _this.targetVersion[1])
                        _this.handleWrongVersion();
                    _this.showScreen();
                })
                    .catch(function () { return _this.errorMessage = 'Server connection failed'; })
                    .finally(function () { return _this.resetInitialState(); });
            };
            LoginController.prototype.resetInitialState = function () {
                // reset all forms back to login
                this.deleteAllCookies();
                this.loginForm = {
                    username: '',
                    password: ''
                };
                this.setPasswordForm = {
                    password1: '',
                    password2: ''
                };
                this.zfaInput = [
                    { value: undefined, index: 0 }, { value: undefined, index: 1 }, { value: undefined, index: 2 },
                    { value: undefined, index: 3 }, { value: undefined, index: 4 }, { value: undefined, index: 5 }
                ];
                this.loginStep = 'credentials';
                this.loginModeMigrateToIdpStep = "enterusername";
                this.userLoginResult = null;
                this.errorMessage = '';
                this.requestNewPwEmail = '';
                this.userLoginResult = undefined;
                this.isLoading = false;
            };
            LoginController.prototype.handleWrongVersion = function () {
                this.wrongVersion = true;
                $('#versionWarningModal').modal('show');
            };
            LoginController.prototype.showScreen = function () {
                var _this = this;
                if (!document.getElementById('login-container')) {
                    setTimeout(function () { _this.showScreen(); }, 500);
                }
                document.getElementById('login-container').style.display = 'block';
                document.getElementById('load-placeholder').style.display = 'none';
            };
            LoginController.prototype.login = function () {
                this.isLoading = true;
                this.errorMessage = "";
                // full idp mode
                if (this.loginMode === 'idp') {
                    this.redirectToIdpLogin("");
                    return;
                }
                // idp migration mode
                if (this.loginMode === 'migratetoidp') {
                    this.doMigrateToIdpLogin();
                    return;
                }
                // classic login
                this.doClassicLogin();
            };
            LoginController.prototype.redirectToIdpLogin = function (username) {
                var newHref = this.baseRoute + 'Login2';
                if (username)
                    newHref = newHref + '?username=' + username;
                window.location.href = newHref;
            };
            LoginController.prototype.doMigrateToIdpLogin = function () {
                var _this = this;
                if (this.loginModeMigrateToIdpStep === "enterusername") {
                    // check username exists
                    this.loginService.checkIdpUserExists(this.loginForm.username)
                        .then(function (data) {
                        // if true redirect to idp login
                        if (data.userExistsInIdp) {
                            console.log('User exists in idp. Redirecting to idp.');
                            _this.redirectToIdpLogin(_this.loginForm.username);
                            return;
                        }
                        // if false show "enter password"
                        _this.loginModeMigrateToIdpStep = "enterpassword";
                        _this.focusPasswordInput();
                        _this.errorMessage = undefined;
                    })
                        .catch(function (data) {
                        var _a;
                        console.log(data.errorMessage);
                        _this.errorMessage = (_a = data.errorMessage) !== null && _a !== void 0 ? _a : "Ein unerwarteter Fehler ist aufgetreten";
                        _this.loginModeMigrateToIdpStep = "enterusername";
                    })
                        .finally(function () { return _this.isLoading = false; });
                }
                else {
                    this.updatePasswordOnLoginSuccessfulRedirect = true;
                    this.loginModeMigrateToIdpStep = "classicloginonce";
                    this.doClassicLogin();
                }
            };
            LoginController.prototype.focusPasswordInput = function () {
                this.$timeout(function () {
                    document.getElementById('login-pass').focus();
                }, 0);
            };
            LoginController.prototype.doClassicLogin = function () {
                var _this = this;
                this.loginService.login(this.loginForm.username, this.loginForm.password, window.navigator.userAgent)
                    .then(function (data) {
                    _this.userLoginResult = data;
                    if (_this.userLoginResult.zfaCheck) {
                        _this.doZfaFlow();
                    }
                    else if (_this.userLoginResult.mustChangePassword) {
                        _this.doChangePasswordFlow();
                    }
                    else {
                        _this.setLocationOnSuccessfulLogin();
                    }
                })
                    .catch(function (data) {
                    _this.errorMessage = _this.formatModelStateErrors(data);
                    _this.errorMessage = _this.errorMessage.length ? _this.errorMessage : 'Ein unbekanntes Problem ist aufgetreten';
                    console.log(_this.errorMessage);
                })
                    .finally(function () { return _this.isLoading = false; });
            };
            LoginController.prototype.formatModelStateErrors = function (modelState) {
                var messages = [];
                if (modelState.hasOwnProperty('resultMessage'))
                    messages.push(modelState.resultMessage);
                else if (Array.isArray(modelState.messages)) {
                    messages = modelState.messages;
                }
                else {
                    for (var key in modelState) {
                        var errors = modelState[key];
                        for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                            var message = errors_1[_i];
                            messages.push("" + message);
                        }
                    }
                }
                return messages.join('; ');
            };
            LoginController.prototype.doZfaFlow = function () {
                this.errorMessage = '';
                this.loginStep = 'zfa';
                localStorage.setItem('loginLock', 'active');
                if (this.userLoginResult.zfaNoEmailAdress || !this.userLoginResult.zfaEmailSent) {
                    this.deleteAllCookies();
                    this.userLoginResult = null;
                    if (this.userLoginResult.zfaNoEmailAdress) {
                        this.errorMessage = (this.userLoginResult.zfaErrMessage && (this.userLoginResult.zfaErrMessage !== "")) ? this.userLoginResult.zfaErrMessage : "Ohne gültige E-Mailadresse ist ein Log in mit 2-Faktor-Authentisierung nicht möglich. Wenden Sie sich bitte an Ihren Administrator";
                    }
                    else if (!this.userLoginResult.zfaEmailSent) {
                        this.errorMessage = (this.userLoginResult.zfaErrMessage && (this.userLoginResult.zfaErrMessage !== "")) ? this.userLoginResult.zfaErrMessage : "Fehler bei E-Mailversand";
                    }
                    return;
                }
                this.focusFirstZfaInputField();
            };
            LoginController.prototype.doChangePasswordFlow = function () {
                this.errorMessage = '';
                this.loginStep = 'pwChange';
                localStorage.setItem('loginLock', 'active');
                this.deleteAllCookies();
                this.isLoading = false;
                this.errorMessage = this.userLoginResult.resultMessage;
                if (!this.userLoginResult.resultMessage)
                    this.goBack();
            };
            LoginController.prototype.setLocationOnSuccessfulLogin = function () {
                var _this = this;
                if (!this.userLoginResult) {
                    this.goBack();
                    return;
                }
                localStorage.removeItem('loginLock');
                window.localStorage.removeItem("NAVIGATION");
                // update password once after first successful login 
                if (this.updatePasswordOnLoginSuccessfulRedirect) {
                    this.callPutNewPassword(this.loginForm.password, this.userLoginResult.accessToken)
                        .then(function () {
                        _this.goBack();
                    });
                    return;
                }
                //this.isLoginProcessing = false;
                window.location.href = this.baseRoute + "#" + this.redirectRoute;
                localStorage.setItem(QMC.Common.LocalStorageConstants.USER_MODULE_PERMISSIONS, JSON.stringify(this.userLoginResult.modulePermissions));
            };
            LoginController.prototype.zfaCancel = function () {
                this.resetInitialState();
            };
            LoginController.prototype.userZfaCheckKey = function () {
                var _this = this;
                this.isLoading = true;
                this.loginService.userZfaCheckKey(this.getZfaInputKey(), window.navigator.userAgent, this.userLoginResult.userId)
                    .then(function (data) {
                    if (data.zfaResult) {
                        _this.errorMessage = '';
                        if (_this.userLoginResult.mustChangePassword) {
                            _this.doChangePasswordFlow();
                            return;
                        }
                        _this.setLocationOnSuccessfulLogin();
                    }
                    else {
                        _this.errorMessage = (data.zfaResultMessage && data.zfaResultMessage !== "") ? data.zfaResultMessage : "Der angegebene Sicherheitscode ist nicht korrekt, versuchen Sie es bitte erneut";
                    }
                })
                    .catch(function (e) {
                    console.error('userZfaCheckKey failed', e);
                    _this.errorMessage = 'Es ist ein fehler aufgetreten, versuchen Sie es bitte erneut';
                })
                    .finally(function () { return _this.isLoading = false; });
            };
            LoginController.prototype.getZfaInputKey = function () {
                var result = "";
                this.zfaInput.map(function (ítem) { return result += ítem.value.toString().replace(" ", "").trim(); });
                return result;
            };
            LoginController.prototype.focusFirstZfaInputField = function () {
                var _a;
                if (this.zfaInput.length > 0) {
                    (_a = document.getElementById('zfaInput0')) === null || _a === void 0 ? void 0 : _a.focus();
                }
            };
            LoginController.prototype.isZfaInputFilled = function () {
                return !this.zfaInput.some(function (item) { return item.value === undefined; });
            };
            LoginController.prototype.onZfaFocus = function (event) {
                if (!(event === null || event === void 0 ? void 0 : event.target))
                    return;
                var element = event.target;
                //lenght of 'zfaInput' + index
                if (element.id.length < 9) {
                    return;
                }
                var slice = element.id.slice(8, element.id.length);
                if (Number.isNaN(slice)) {
                    return;
                }
                var index = Number(slice);
                this.zfaInput[index].value = undefined;
            };
            LoginController.prototype.onZfaKeyUp = function (event) {
                var _a;
                return __awaiter(this, void 0, void 0, function () {
                    var element, index, clipboardValue_1, _loop_1, this_1, i, e_1;
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!(event === null || event === void 0 ? void 0 : event.target))
                                    return [2 /*return*/];
                                element = event.target;
                                element.setAttribute('disabled', 'disabled'); //lock the input field for the time of this event
                                index = +((_a = element.id) === null || _a === void 0 ? void 0 : _a.charAt(element.id.length > 0 ? element.id.length - 1 : 0));
                                switch (event.key) {
                                    case 'ArrowLeft':
                                    case 'Backspace':
                                        this.zfaGoLeft(index);
                                        break;
                                    case 'ArrowRight':
                                    case '0':
                                    case '1':
                                    case '2':
                                    case '3':
                                    case '4':
                                    case '5':
                                    case '6':
                                    case '7':
                                    case '8':
                                    case '9':
                                        this.zfaGoRight(index);
                                        break;
                                }
                                if (!(event.keyCode === 86)) return [3 /*break*/, 4];
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 3, , 4]);
                                this.zfaInput.map(function (item) { return document.getElementById('zfaInput' + item.index).setAttribute('disabled', 'disabled'); });
                                return [4 /*yield*/, navigator.clipboard.readText()];
                            case 2:
                                clipboardValue_1 = _b.sent();
                                //number inside the clipboard?
                                if (clipboardValue_1 === '' || Number.isNaN(clipboardValue_1)) {
                                    return [2 /*return*/];
                                }
                                if (clipboardValue_1.length > this.zfaInput.length) {
                                    clipboardValue_1 = clipboardValue_1.substring(0, this.zfaInput.length - 1);
                                }
                                _loop_1 = function (i) {
                                    if (!Number.isNaN(clipboardValue_1[i])) {
                                        // Trigger Angular's change detection manually
                                        // force Angular to update the view
                                        this_1.$scope.$apply(function () {
                                            _this.zfaInput[i].value = Number(clipboardValue_1[i]);
                                            //const inputElement: HTMLInputElement = document.getElementById('zfaInput' + i) as HTMLInputElement;
                                            //inputElement.value = clipboardValue[i];
                                        });
                                    }
                                };
                                this_1 = this;
                                for (i = 0; i < clipboardValue_1.length; i++) {
                                    _loop_1(i);
                                }
                                this.$scope.$apply();
                                this.zfaInput.map(function (item) { return document.getElementById('zfaInput' + item.index).removeAttribute('disabled'); });
                                element.setAttribute('disabled', 'disabled');
                                return [3 /*break*/, 4];
                            case 3:
                                e_1 = _b.sent();
                                console.error('failure while trying to paste clipboard into input fields', e_1);
                                return [3 /*break*/, 4];
                            case 4:
                                // this input has or should have ng-maximun = 1, but sometimes that doesn´t do the job...
                                if (element.value.length > 1)
                                    element.value = element.value.slice(0, 1);
                                element.removeAttribute('disabled'); //unlock the input field
                                return [2 /*return*/];
                        }
                    });
                });
            };
            //get the next element and set focus
            LoginController.prototype.zfaGoRight = function (index) {
                var nextIndex = index + 1;
                if (nextIndex > this.zfaInput.length - 1)
                    return;
                var nextElementId = 'zfaInput' + nextIndex;
                var nextElement = document.getElementById(nextElementId);
                if (nextElement) {
                    nextElement.focus();
                }
            };
            //get the previous element and set focus
            LoginController.prototype.zfaGoLeft = function (index) {
                var previousIndex = index - 1;
                if (previousIndex < 0) {
                    this.focusFirstZfaInputField();
                    return;
                }
                var previousElementId = 'zfaInput' + previousIndex;
                var previousElement = document.getElementById(previousElementId);
                if (previousElement) {
                    previousElement.focus();
                }
            };
            LoginController.prototype.changePw = function () {
                var _this = this;
                this.isLoading = true;
                this.loginService.checkPasswordRules(this.setPasswordForm.password1)
                    .then(function (data) {
                    if (data.error) {
                        _this.errorMessage = data.errorList.join('\r\n');
                    }
                    else {
                        return _this.callPutNewPassword(_this.setPasswordForm.password1, _this.userLoginResult.accessToken)
                            .then(function () {
                            // all login stuff done - continue
                            _this.deleteAllCookies();
                            _this.setLocationOnSuccessfulLogin();
                            _this.hasDonePwReset = true;
                        });
                    }
                })
                    .catch(function () { return _this.errorMessage = 'Fehler beim Überprüfen des Passwords'; })
                    .finally(function () { return _this.isLoading = false; });
            };
            LoginController.prototype.callPutNewPassword = function (password, token) {
                var _this = this;
                var deferred = this.$q.defer();
                this.loginService.putNewPassword(null, password, token)
                    .then(function () {
                    deferred.resolve();
                })
                    .catch(function (data) {
                    console.error('Pw update failed', data);
                    _this.isLoading = false;
                    if (data.fieldErrors && data.fieldErrors.hasOwnProperty('currentPassword')) {
                        for (var _i = 0, _a = data.fieldErrors.currentPassword; _i < _a.length; _i++) {
                            var element = _a[_i];
                            _this.errorMessage += element + " ";
                        }
                    }
                    else if (data.fieldErrors && data.fieldErrors.hasOwnProperty('newPassword')) {
                        for (var _b = 0, _c = data.fieldErrors.newPassword; _b < _c.length; _b++) {
                            var element = _c[_b];
                            _this.errorMessage += element + " ";
                        }
                    }
                    else
                        _this.errorMessage = "Ein unbekannter Fehler ist aufgetreten. Das Passwort konnte nicht geändert werden.";
                    deferred.reject(data);
                });
                return deferred.promise;
            };
            LoginController.prototype.resetPw = function () {
                var _this = this;
                this.isLoading = true;
                this.loginService.resetUserPassword(this.requestNewPwEmail)
                    .then(function () {
                    var section = document.getElementById('reset-pw-section');
                    section.style.display = 'none';
                    _this.errorMessage = 'Ihnen wurde ein neues Passwort zugesendet. Bitte überprüfen Sie Ihre Emails.';
                })
                    .catch(function (e) {
                    var error = [];
                    if (e && Array.isArray(e.GlobalErrors))
                        error = error.concat(e.GlobalErrors);
                    if (e && Array.isArray(e.FieldErrors))
                        error = error.concat(e.FieldErrors);
                    if (error.length === 0)
                        error.push('Es ist ein Fehler aufgetreten. Das Passwort konnte nicht zurückgesetzt werden.');
                    _this.errorMessage = error.join('; ');
                    console.error('Pw reset failed', e);
                })
                    .finally(function () { return _this.isLoading = false; });
            };
            LoginController.prototype.deleteAllCookies = function () {
                var cookies = document.cookie.split(";");
                for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
                    var element = cookies_1[_i];
                    var cookie = element;
                    var eqPos = cookie.indexOf("=");
                    var name_1 = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                    document.cookie = name_1 + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                }
            };
            LoginController.prototype.goBack = function () {
                window.location.href = this.baseRoute + "#" + this.redirectRoute + (this.redirectRoute.indexOf('?') > -1 ? '&' : '?') + 'dbConnectionString=' + angular.element('#connection').data("db-options");
            };
            LoginController.$inject = ['LoginService', '$scope', '$q', '$timeout'];
            return LoginController;
        }());
        Login.LoginController = LoginController;
    })(Login = QMC.Login || (QMC.Login = {}));
})(QMC || (QMC = {}));
(function () {
    angular
        .module('QMC.Login')
        .controller('LoginController', QMC.Login.LoginController);
})();
var QMC;
(function (QMC) {
    var Login;
    (function (Login) {
        var LoginService = /** @class */ (function () {
            function LoginService($http, $q) {
                this.$http = $http;
                this.$q = $q;
                var sessionData = $('#session').data();
                this.apiData = { url: sessionData.api, key: sessionData.apiKey };
            }
            LoginService.prototype.getLanguages = function () {
                var deferred = this.$q.defer();
                this.$http.get(this.apiData.url + '/Languages', { params: { dbConnectionString: angular.element('#connection').data("db-options") } })
                    .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise;
            };
            LoginService.prototype.getVersion = function () {
                var deferred = this.$q.defer();
                this.$http.get(this.apiData.url + '/Info', { params: { dbConnectionString: angular.element('#connection').data("db-options") } })
                    .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise;
            };
            LoginService.prototype.login = function (username, password, clientKey) {
                var deferred = this.$q.defer();
                // Current url without parameters
                var currentUrl = location.protocol + '//' + location.host + location.pathname;
                this.$http.post(currentUrl, {
                    UserName: username,
                    Password: password,
                    ClientKey: clientKey,
                    DbConnection: angular.element('#connection').data("db-options")
                }).then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise;
            };
            LoginService.prototype.checkIdpUserExists = function (username) {
                var deferred = this.$q.defer();
                this.$http.get(this.apiData.url + '/IDP/UserExists', { params: { username: username, dbConnectionString: angular.element('#connection').data("db-options") } })
                    .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise;
            };
            LoginService.prototype.userZfaCheckKey = function (key, clientKey, userId) {
                var deferred = this.$q.defer();
                var url = this.apiData.url + "/User/ZfaCheck";
                this.$http.post(url, { Key: key, ClientKey: clientKey, UserId: userId }).then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise;
            };
            LoginService.prototype.resetUserPassword = function (email) {
                var deferred = this.$q.defer();
                var url = this.apiData.url + "/User/ResetPassword";
                this.$http.post(url, { email: email }).then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise;
            };
            LoginService.prototype.checkPasswordRules = function (newPassword) {
                var deferred = this.$q.defer();
                var url = this.apiData.url + "/User/CheckPasswordRules/";
                this.$http.post(url, { Password: newPassword }).then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise;
            };
            LoginService.prototype.putNewPassword = function (currentPassword, newPassword, token) {
                if (token === void 0) { token = ""; }
                var deferred = this.$q.defer();
                this.$http.put(this.apiData.url + '/User/Password', {
                    CurrentPassword: currentPassword,
                    NewPassword: newPassword
                }, { headers: { 'Authorization': "Bearer " + token } }).then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise;
            };
            LoginService.prototype.startTimeTracking = function () {
                var deferred = this.$q.defer();
                this.$http.post(this.apiData.url + '/TimeTracking/Start', {}).then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise;
            };
            LoginService.prototype.keepSessionAlive = function (token) {
                var deferred = this.$q.defer();
                this.$http.put(this.apiData.url + '/session/qmc', {}, { headers: { 'Authorization': "Bearer " + token } }).then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise;
            };
            LoginService.$inject = ['$http', '$q'];
            return LoginService;
        }());
        Login.LoginService = LoginService;
    })(Login = QMC.Login || (QMC.Login = {}));
})(QMC || (QMC = {}));
(function () {
    angular
        .module('QMC.Login')
        .service('LoginService', QMC.Login.LoginService);
})();
var QMC;
(function (QMC) {
    var NewsFeed;
    (function (NewsFeed) {
        var NewsFeedDirective = /** @class */ (function () {
            function NewsFeedDirective(newsFeedService) {
                var _this = this;
                this.newsFeedService = newsFeedService;
                this.mainFeed = new NewsFeed.NewsFeedItem();
                this.subFeeds = [];
                this.backgroundImgUrl = '';
                this.currentYear = new Date().getFullYear().toString();
                this.hasError = false;
                this.errorMessage = '';
                this.maxDisplayedSubFeeds = 5;
                this.$postLink = function () { _this.init(); };
            }
            NewsFeedDirective.prototype.init = function () {
                this.getNewsFeedData();
                if (!this.hasError && this.mainFeed) {
                    this.show();
                }
            };
            NewsFeedDirective.prototype.show = function () {
                var _this = this;
                if (!document.getElementById('newsfeed-content')) {
                    setTimeout(function () { _this.show(); }, 500);
                }
                document.getElementById('newsfeed-load-placeholder').style.display = 'none';
                document.getElementById('newsfeed-content').style.display = 'block';
                document.getElementById('newsfeed-container').style.flexGrow = "1";
            };
            NewsFeedDirective.prototype.getNewsFeedData = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var feed;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.newsFeedService.getNewsFeed()];
                            case 1:
                                feed = _a.sent();
                                if (feed) {
                                    this.getNewsFeedImage(feed);
                                    this.getNewsFeedItems(feed);
                                }
                                return [2 /*return*/];
                        }
                    });
                });
            };
            NewsFeedDirective.prototype.getNewsFeedImage = function (feed) {
                var _a;
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_b) {
                        try {
                            this.backgroundImgUrl = (_a = feed.rss.channel.image.url) !== null && _a !== void 0 ? _a : '';
                        }
                        catch (_c) {
                            console.error('A problem occurred while loading the Background Image.');
                        }
                        return [2 /*return*/];
                    });
                });
            };
            NewsFeedDirective.prototype.getNewsFeedItems = function (feed) {
                var _a;
                return __awaiter(this, void 0, void 0, function () {
                    var feedsLength, arr;
                    return __generator(this, function (_b) {
                        try {
                            //main feed
                            if (feed.rss.channel.item.length > 0) {
                                this.mainFeed = (_a = feed.rss.channel.item[0]) !== null && _a !== void 0 ? _a : new NewsFeed.NewsFeedItem();
                            }
                            //sub feeds
                            if (feed.rss.channel.item.length > 1) {
                                feedsLength = Math.min(feed.rss.channel.item.length + 1, this.maxDisplayedSubFeeds + 1);
                                arr = feed.rss.channel.item.slice(1, feedsLength);
                                this.subFeeds = arr;
                            }
                        }
                        catch (_c) {
                            this.subFeeds = [];
                            this.hasError = true;
                            console.error('A problem occurred while loading the NewsFeed items.');
                        }
                        return [2 /*return*/];
                    });
                });
            };
            return NewsFeedDirective;
        }());
        NewsFeed.NewsFeedDirective = NewsFeedDirective;
        angular
            .module('QMC.NewsFeed')
            .component('newsfeed', {
            templateUrl: $('#session').data().baseUrl + 'Templates/LoginNewsFeed',
            controller: ['NewsFeedService', NewsFeedDirective],
            controllerAs: 'vm'
        });
    })(NewsFeed = QMC.NewsFeed || (QMC.NewsFeed = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var NewsFeed;
    (function (NewsFeed_1) {
        var NewsFeed = /** @class */ (function () {
            function NewsFeed() {
            }
            return NewsFeed;
        }());
        NewsFeed_1.NewsFeed = NewsFeed;
        var NewsFeedRss = /** @class */ (function () {
            function NewsFeedRss() {
            }
            return NewsFeedRss;
        }());
        NewsFeed_1.NewsFeedRss = NewsFeedRss;
        var NewsFeedChannel = /** @class */ (function () {
            function NewsFeedChannel() {
                this.item = [];
            }
            return NewsFeedChannel;
        }());
        NewsFeed_1.NewsFeedChannel = NewsFeedChannel;
        var NewsFeedImage = /** @class */ (function () {
            function NewsFeedImage() {
            }
            return NewsFeedImage;
        }());
        NewsFeed_1.NewsFeedImage = NewsFeedImage;
        var NewsFeedItem = /** @class */ (function () {
            function NewsFeedItem(jsonItem) {
                var _a, _b, _c, _d, _e;
                this.link = (_a = jsonItem === null || jsonItem === void 0 ? void 0 : jsonItem.link) !== null && _a !== void 0 ? _a : "";
                this.title = (_b = jsonItem === null || jsonItem === void 0 ? void 0 : jsonItem.title) !== null && _b !== void 0 ? _b : "";
                this.description = (_c = jsonItem === null || jsonItem === void 0 ? void 0 : jsonItem.description[0]) !== null && _c !== void 0 ? _c : "";
                this.published = (_d = jsonItem === null || jsonItem === void 0 ? void 0 : jsonItem.published) !== null && _d !== void 0 ? _d : "";
                this.category = (_e = jsonItem === null || jsonItem === void 0 ? void 0 : jsonItem.category) !== null && _e !== void 0 ? _e : "";
            }
            return NewsFeedItem;
        }());
        NewsFeed_1.NewsFeedItem = NewsFeedItem;
    })(NewsFeed = QMC.NewsFeed || (QMC.NewsFeed = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var NewsFeed;
    (function (NewsFeed) {
        var NewsFeedService = /** @class */ (function () {
            function NewsFeedService($http, $q) {
                this.$http = $http;
                this.$q = $q;
                this.newsfeedUrl = 'https://update.qmcenter.de/technews-de.xml';
                var sessionData = $('#session').data();
                this.apiData = { url: sessionData.api, key: sessionData.apiKey };
            }
            NewsFeedService.prototype.getNewsFeed = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var result, _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, this.getFeedFromUrl()];
                            case 1:
                                result = _b.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                _a = _b.sent();
                                console.error('A problem occurred while loading the NewsFeed from ' + this.newsfeedUrl);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/, result];
                        }
                    });
                });
            };
            NewsFeedService.prototype.getFeedFromUrl = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var xmlDoc, feed;
                    return __generator(this, function (_a) {
                        xmlDoc = this.getNewsFeedAsXml();
                        feed = this.parseFeed(xmlDoc);
                        return [2 /*return*/, feed];
                    });
                });
            };
            NewsFeedService.prototype.getNewsFeedAsXml = function () {
                var result = null;
                var xmlHttpRequest = new XMLHttpRequest();
                xmlHttpRequest.open('GET', this.newsfeedUrl, false);
                xmlHttpRequest.send(null);
                if (xmlHttpRequest.responseXML)
                    result = xmlHttpRequest.responseXML;
                return result;
            };
            NewsFeedService.prototype.parseFeed = function (xmlDoc) {
                var feed = new NewsFeed.NewsFeed();
                feed.rss = new NewsFeed.NewsFeedRss();
                feed.rss.channel = new NewsFeed.NewsFeedChannel();
                if (!xmlDoc)
                    return feed;
                var rssElement = xmlDoc.getElementsByTagName('rss')[0];
                var channelElement = rssElement.getElementsByTagName('channel')[0];
                feed.rss.channel = this.parseNewsFeedChannel(channelElement);
                return feed;
            };
            NewsFeedService.prototype.parseNewsFeedChannel = function (channelElement) {
                var result = new NewsFeed.NewsFeedChannel();
                //image
                var imageElement = channelElement.getElementsByTagName('image')[0];
                result.image = this.parseNewsFeedImage(imageElement);
                //item
                var itemElements = channelElement.getElementsByTagName('item');
                for (var i = 0; i < itemElements.length; i++) {
                    var itemElement = itemElements[i];
                    var item = this.parseItem(itemElement);
                    result.item.push(item);
                }
                return result;
            };
            NewsFeedService.prototype.parseNewsFeedImage = function (imageElement) {
                var result = new NewsFeed.NewsFeedImage();
                if (imageElement) {
                    result.url = this.getElementTextContent(imageElement, 'url');
                    result.title = this.getElementTextContent(imageElement, 'title');
                    result.link = this.getElementTextContent(imageElement, 'link');
                }
                return result;
            };
            NewsFeedService.prototype.parseItem = function (itemElement) {
                var item = new NewsFeed.NewsFeedItem();
                if (itemElement) {
                    item.link = this.getElementTextContent(itemElement, 'link');
                    item.title = this.getElementTextContent(itemElement, 'title');
                    item.description = this.getElementTextContent(itemElement, 'description');
                    item.published = new Date(this.getElementTextContent(itemElement, 'pubDate'));
                    item.category = this.getElementTextContent(itemElement, 'category');
                }
                return item;
            };
            NewsFeedService.prototype.getElementTextContent = function (parentElement, tagName) {
                var elements = parentElement.getElementsByTagName(tagName);
                if (elements.length > 0) {
                    return elements[0].textContent || '';
                }
                return '';
            };
            NewsFeedService.$inject = ['$http', '$q'];
            return NewsFeedService;
        }());
        NewsFeed.NewsFeedService = NewsFeedService;
    })(NewsFeed = QMC.NewsFeed || (QMC.NewsFeed = {}));
})(QMC || (QMC = {}));
(function () {
    angular
        .module('QMC.NewsFeed')
        .service('NewsFeedService', [QMC.NewsFeed.NewsFeedService]);
})();

//# sourceMappingURL=../maps/qmc.login.js.map
